<template>
  <section class="video__intro__wrapper">
    <div
      v-if="!loaded"
      class="loading-count"
      id="loading_count"
    >
      <p>{{loadingCount}}</p>
    </div>
    <div
      class="confirm"
      :class="!confirmed && loaded?'d-block':animationstart?'d-animation':'d-none'"
    >
      <p
      >Please confirm you are aged over 18</p>
      <p
        @click="conform"
        @mouseenter="MX_isZoom(true)"
        @mouseleave="MX_isZoom(false)"
      >
        Yes
      </p>
    </div>
    <div v-if="confirmed && loaded && animationend" class="video_section">
      <video
        muted
        playsinline
        autoplay
        @ended="onVideoEnd"
      >
        <source src="@/assets/videos/logoanimation.mp4" type="video/mp4">
      </video>
      <div
        class="email__intro__wrapper"
        v-show="isVideoEnded"
      >
        <!-- <span
          @click="playMusic"
          @click.native="playMusic"
          @mouseenter="playMusicHover"
          @mouseleave="MX_isZoom(false)"
        >
          Discover
        </span> -->
        <router-link
          to='/intro-discover'
          @click.native="playMusic"
          @mouseover.native="playMusicHover"
          @mouseenter.native="MX_isZoom(true)"
          @mouseleave.native="MX_isZoom(false)"
          :class="!confirmed1?'d-block':'d-animation'"
        >
          Discover
        </router-link>
        
        <span
          @click.native="playMusic"
          @click="toMemberPage"
          @mouseover.native="playMusicHover"
          @mouseenter.native="MX_isZoom(true)"
          @mouseleave.native="MX_isZoom(false)"
          :class="!confirmed1?'d-block':'d-animation'"
        >
          Member
        </span>

      </div>
    </div>
  </section>
</template>

<script>
import { isZooming } from '../mixins/isZooming'
import { mapGetters } from 'vuex'

export default {
  name: 'Index',
  mixins: [
    isZooming
  ],
  data () {
    return {
      isVideoEnded: false,
      confirmed: false,
      confirmed1: false,
      intervalVolumn: 200,
      loaded: false,
      loadingCount: 0,
      animationstart: false,
      animationstart1: false,
      animationend: false,
      firstTrackVolumn: 1
    }
  },
  computed: {
    isMusicOn: {
      get () {
        return this.$store.state.audio.isMusicOn
      },
      set (payload) {
        this.$store.commit('updateAudioStatus', payload)
      }
    },
    ...mapGetters([
      'generateAudioPath',
      // 'generateHoverAudioPath',
      'generateOpenAudioPath'
      // 'generateCrossAudioPath'
    ])
  },
  mounted () {
    this.generateOpenAudioPath.load()
    // this.generateOpenAudioPath.pause()
    this.generateAudioPath.load()
    // this.generateAudioPath.pause()
    this.$store.commit('updateCursorType', 1)
    document.getElementById('loading_count').style.opacity = 1
    let countDown = setInterval(() => {
      this.loadingCount += 1
      document.getElementById('loading_count').style.opacity -= 0.01
      if (this.loadingCount >= 100) {
        clearInterval(countDown)
        setTimeout(() => {
          this.loaded = !this.loaded
          document.getElementById('loading_count').style.opacity = 1
        }, 100)
      }
    }, 10)
  },
  methods: {
    conform () {
      this.MX_isZoom(false)
      this.confirmed = !this.confirmed
      this.animationstart = !this.animationstart
      this.$store.commit('updateCursorHidden', true)
      setTimeout(() => {
        this.animationstart = !this.animationstart
        this.animationend = !this.animationend
      }, 1000)
      this.isMusicOn = true
      if (this.isMusicOn && !(!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform))) {
        this.generateAudioPath.pause()
        this.generateOpenAudioPath.volume = 0
        this.generateOpenAudioPath.play()
        let currentVolume = 0
        let volumeUp = setInterval(() => {
          currentVolume += 0.15
          this.generateOpenAudioPath.volume = currentVolume < this.firstTrackVolumn ? currentVolume : this.firstTrackVolumn
          if (this.generateOpenAudioPath.volume === this.firstTrackVolumn) {
            clearInterval(volumeUp)
          }
        }, 200)
      }
    },
    onVideoEnd () {
      // When video has finished, animate the
      // "Discover" and "Member" links
      this.isVideoEnded = true
      this.$store.commit('updateCursorHidden', false)
    },
    fadeDownMusic () {
      // Turn music off on hover of "Discover"
      this.$root.$emit('isFadeDownMusic', true)
    },
    fadeInMusic () {
      // Turn music on on hover of "Discover"
      this.$root.$emit('isFadeInMusic', true)
    },
    playMusic () {
      this.confirmed1 = true
      setTimeout(() => {
        this.animationstart1 = false
      }, 1000)
    },
    playMusicHover () {
      this.MX_isZoom(true)
      if (document.body.clientWidth >= 763 && this.generateOpenAudioPath.volume === this.firstTrackVolumn && this.confirmed) {
        this.fadeDown()
      }
    },
    fadeDown () {
      let currentVolume1 = this.generateOpenAudioPath.volume
      this.volumeDown = setInterval(() => {
        if (this.generateOpenAudioPath.volume === 0) {
          this.generateOpenAudioPath.currentTime = 0
          this.generateOpenAudioPath.pause()
          // this.isMusicOn = !this.isMusicOn
          clearInterval(this.volumeDown)
        }
        currentVolume1 -= 0.025
        this.generateOpenAudioPath.volume = currentVolume1 > 0 ? currentVolume1 : 0
      }, 100)
    },
    // TODO:
    // DISABLED FOR NOW
    // @mouseenter.native="fadeDownMusic"
    // @mouseleave.native="fadeInMusic"

    toMemberPage () {
      window.location.href =  "https://members.burgundyscollection.com"
    }
  }
}
</script>
